export default __webpack_public_path__ + "static/media/Configuracoes.61a2e98e.svg";